import {IJackpotBetsInfoModel} from "../models/jackpot-bets-info.model.interfeace";
import {IJackpotBetsStrategy} from "./jackpot-bets-strategy.interface";

export class VoidJackpotBetsStrategy implements IJackpotBetsStrategy {
    readonly jackpotBetsInfo: IJackpotBetsInfoModel | null = null;
    dispose(): void {
    }
}